export class DragDropToken {

	id: number;
	text: string;
	isUsed: boolean;
	number: number;

}
